import * as R from 'ramda';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import React, { useEffect } from 'react';
// helpers/constants
import * as G from '../../../../helpers';
import * as GC from '../../../../constants';
// forms
import { Fieldset2 } from '../../../../forms';
// icons
import * as I from '../../../../svgs';
// ui
import { Box, Span, Flex } from '../../../../ui';
//////////////////////////////////////////////////

const validationSchema = Yup.lazy(({ summarySubgroup }) => Yup.object().shape({
  showLastDays: G.yupNumberNotRequired
    .min(0, G.getShouldBeFromToLocaleTxt(0, 100))
    .max(100, G.getShouldBeFromToLocaleTxt(0, 100)),
  [GC.FIELD_SUMMARY_GROUP]: G.ifElse(
    G.isNotNilAndNotEmpty(summarySubgroup),
    G.yupStringRequired,
  ),
}));

const inputWrapperStyles = {
  mb: 25,
  width: 145,
};

const GroupBySort = ({ values, setFieldValue }) => {
  if (R.propEq(GC.ORGANIZE_BY_NO_GROUPING, GC.FIELD_GROUP_BY, values)) return null;

  const groupBySort = R.pathOr(GC.SORT_TYPE_DESC, [GC.FIELD_GROUP_BY_SORT], values);
  const isAscOrder = R.equals(groupBySort, GC.SORT_TYPE_ASC);
  const icon = G.ifElse(isAscOrder, I.arrowUp, I.arrowDown);

  return (
    <Flex
      cursor='pointer'
      onClick={() => setFieldValue(GC.FIELD_GROUP_BY_SORT, G.ifElse(isAscOrder, GC.SORT_TYPE_DESC, GC.SORT_TYPE_ASC))}
      title={`${G.getWindowLocale('titles:organize-by', 'Organize By')} ${
        G.getWindowLocale('titles:sort', 'Sort')}: ${groupBySort}`}
    >
      {icon(G.getTheme('colors.dark.mainDark'))}
    </Flex>
  );
};

const getFieldSettings = (formik) => [
  {
    type: 'text',
    inputWrapperStyles,
    fieldName: 'showLastDays',
    label: ['titles:days-before'],
  },
  {
    type: 'select',
    inputWrapperStyles,
    options: 'groupByOptions',
    fieldName: GC.FIELD_GROUP_BY,
    label: ['titles:organize-by'],
    additionalLabelStyles: { top: 10, right: -15 },
    additionalLabelComponent: <GroupBySort {...formik} />,
  },
  {
    type: 'select',
    options: 'summaryOptions',
    label: ['titles:summary-group'],
    fieldName: GC.FIELD_SUMMARY_GROUP,
    inputWrapperStyles: {
      mb: 15,
      width: 145,
    },
  },
  {
    isMulti: true,
    type: 'select',
    options: 'summaryOptions',
    label: ['titles:summary-sub-group'],
    fieldName: GC.FIELD_SUMMARY_SUBGROUP,
    inputWrapperStyles: {
      mb: 15,
      width: 145,
    },
  },
];

const ReportSummary = (props) => {
  const { groupByOptions, setFormValues, summaryOptions, initialValues } = props;

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: () => {},
  });

  const { values } = formik;

  useEffect(() => {
    setFormValues(R.mergeLeft(values));
  }, [values]);

  return (
    <Box width='100%'>
      <Flex
        p='0 15px'
        height={40}
        borderBottom='1px solid'
        justifyContent='space-between'
        color={G.getTheme('colors.light.black')}
        bg={G.getTheme('colors.light.lightGrey')}
        borderColor={G.getTheme('colors.lightGrey')}
      >
        <Span>{G.getWindowLocale('titles:settings', 'Settings')}</Span>
      </Flex>
      <Fieldset2
        {...formik}
        groupByOptions={groupByOptions}
        fields={getFieldSettings(formik)}
        summaryOptions={G.addEmptyOptionToDropDown(summaryOptions)}
        fieldsWrapperStyles={{
          mt: 20,
          pl: 15,
          pr: 10,
          width: 330,
          gridColumnGap: 15,
          justifyContent: 'space-between',
        }}
      />
    </Box>
  );
};

export default ReportSummary;
